import antdData from 'antd/lib/locale-provider/ru_RU'
import {createIntl, createIntlCache} from 'react-intl'
import 'moment/locale/ru'

const messages = {
  // TITLES
  'title.main': 'Главная',
  'title.news': 'Новости',
  'title.legal': 'Правовая информация',
  'title.partners': 'Мои партнеры',
  'title.journal': 'Журнал',
  'title.finance': 'Финансы',
  'title.referral-links': 'Мои ссылки',
  'title.photobank': 'Фотобанк',
  'title.videobank': 'Видеобанк',
  'title.files': 'Файлы',
  'title.sales-report': 'Отчет о продажах',
  'title.diagnostician-materials': 'Диагностика',
  // MENU
  'menu.left.profile.available': 'Доступно',
  'menu.left.profile.income': 'Ожидаемая выплата',
  'menu.left.profile.business-reputation': 'Business Reputation',
  'menu.left.profile.business-reputation-info-tooltip': 'Информация об этом показателе',
  'menu.left.logout': 'Выйти',
  'menu.left.goto-masterkit': 'В Master Kit',
  'menu.left.marketing-plan': 'Маркетинг-план',
  'menu.left.support': 'Служба поддержки',
  'menu.left.useful-materials': 'Полезные материалы',
  // DIAGNOSTICS
  'menu.left.diagnostics.title': 'Продано диагностик',
  'menu.left.diagnostics.details.last7Days': 'за 7 дней',
  'menu.left.diagnostics.details.last30Days': 'за 30 дней',
  'menu.left.diagnostics.details.total': 'всего',
  'menu.left.profileSnippet.diagnostics.top': 'ТОП',
  // ACTIVATION
  'menu.left.profile.activation.title': 'Активация',
  'menu.left.profile.activation.notExecuted': 'Не выполнена',
  'menu.left.profile.activation.daysLeft': '{daysLeft, plural, one {Остался # день} many {Осталось # дней} few {Осталось # дня} other {Осталось # дней}}',
  'menu.left.profile.activation.expiresAt': 'Действует до \n{date}',
  // SETTINGS
  'components.locale-settings-modal.title': 'Выберите язык',
  'components.locale-settings-modal.change-confirm': 'Сменить язык на {language}?',
  'components.locale-settings-modal.change-confirm.yes': 'Да',
  'components.locale-settings-modal.change-confirm.no': 'Отмена',
  'components.legal-info.download-document': 'Скачать документ',
  'locales.russian': 'русский',
  'locales.english': 'английский',
  'locales.bulgarian': 'болгарский',
  'locales.french': 'французский',
  'locales.deutsch': 'немецкий',
  'locales.hungarian': 'венгерский',
  'locales.italian': 'итальянский',
  'locales.kazakh': 'казахский',
  'locales.latvian': 'латышский',
  'locales.spanish': 'испанский',
  'locales.turkish': 'турецкий',
  // COMMON Components
  'components.profile-snippet.logout': 'Выйти из кабинета',
  'components.commissions-modal.title': 'Детализация комиссий',
  'components.commissions-modal.table.user': 'За кого',
  'components.commissions-modal.table.level': 'Ур.',
  'components.commissions-modal.table.date': 'Дата',
  'components.commissions-modal.table.product': 'Продукт',
  'components.commissions-modal.table.commission': 'Объем',
  'components.commissions-modal.table.percent': 'Процент',
  'components.commissions-modal.table.amount': 'Сумма',
  'components.commissions-modal.table.status': 'Статус',
  'components.commissions-modal.table.user.external': 'Пользователь может не состоять в вашей структуре',
  'components.cookies-policy-agreement.text': 'Используя наш сайт, вы подтверждаете, что прочитали и поняли политику о куки, политику конфиденциальности и пользовательское соглашение.',
  'components.cookies-policy-agreement.agree-button': 'Хорошо',
  'components.cookies-policy-agreement.docs-link-text': "Ознакомиться с информацией",
  'components.commissions-modal.status.active': 'В процессе',
  'components.commissions-modal.status.rejected': 'Отменено',
  'components.commissions-modal.status.paid_out': 'Выполнено',
  'components.rich-progress-bar.percentage-of-completion': 'Выполнено на {percent}%',
  'components.card-select.add-new': 'Добавить новую карту',
  'components.remove-card.tooltip': 'Удаление карты',
  'components.remove-card.success-message': 'Карта успешно удалена',
  'components.remove-card.confirmation-text': 'Удалить карту?',
  'components.remove-card.warning-text': 'Все незавершенные операции\nсвязанные с этой картой будут отменены',
  'components.remove-card.yes': 'Да',
  'components.remove-card.cancel': 'Отмена',
  // COMMON Components - error-boundary
  'components.error-boundary.title': 'В модуле произошла ошибка',
  'components.error-boundary.message-sent': 'Сообщение о ней отправлено в поддержку и скоро мы её устраним.',
  'components.error-boundary.you-can': 'Вы можете',
  'components.error-boundary.re-login': 'Войти заново',
  'components.error-boundary.or': 'или',
  'components.error-boundary.refresh-page': 'Обновить страницу',
  'components.error-boundary.solve-yourself': 'чтобы попробовать решить проблему самостоятельно.',
  // Notifications
  'notifications.empty': 'Нет новых уведомлений',
  'notifications.notification.remittance.incoming.title': 'Входящий перевод {amount}',
  'notifications.notification.remittance.incoming.description': 'от {fullname}',
  'notifications.notification.remittance.outgoing.title': 'Выполнен перевод {amount}',
  'notifications.notification.remittance.outgoing.description': 'пользователю {fullname}',
  'notifications.notification.goal-report.income.title': 'Получен отчет о выполнении цели',
  'notifications.notification.goal-report.income.description': 'Цель: получить доход',
  'notifications.notification.goal-report.qualification.title': 'Получен отчет о выполнении цели',
  'notifications.notification.goal-report.qualification.description': 'Цель: получить квалификацию',
  'notifications.notification.withdrawal.title': 'Вывод средств',
  'notifications.notification.withdrawal.approved': 'Операция подтверждена',
  'notifications.notification.withdrawal.rejected': 'Операция отклонена',
  'notifications.notification.withdrawal.canceled': 'Операция отменена',
  'notifications.notification.survey.title': 'Вам необходимо пройти опрос',
  'notifications.notification.diagnostician-certificate.granted': 'Вы прошли аттестацию\nТеперь вы можете проводить диагностику',
  'notifications.notification.diagnostician-certificate.revoked': 'Ваша аттестация отозвана\nВы больше не можете проводить диагностику',
  // QUALIFICATIONS
  'qualification.client': 'Клиент',
  'qualification.intern': 'Стажер',
  'qualification.partner': 'Партнер',
  'qualification.official_partner': 'Официальный партнер',
  'qualification.mentor': 'Наставник',
  'qualification.regional_mentor': 'Региональный бизнес наставник',
  'qualification.international_mentor': 'Международный бизнес наставник',
  'qualification.top_leader': 'Топ лидер',
  'qualification.shareholder': 'Акционер',
  'qualification.business_mentor': 'Бизнес наставник',
  'qualification.lead_shareholder': 'Ведущий акционер',
  'qualification.regional_mentor_first_month': 'Региональный бизнес наставник (1 месяц)',
  'qualification.shareholder_first_month': 'Акционер (1 месяц)',
  'qualification.shareholder_second_month': 'Акционер (2 месяц)',
  'qualification.top_leader_first_month': 'Топ лидер (1 месяц)',
  'qualification.top_leader_second_month': 'Топ лидер (2 месяц)',
  'qualification.international_mentor_first_month': 'Международный бизнес наставник (1 месяц)',
  'qualification.curator': 'Куратор',
  'qualification.organizer': 'Организатор',
  'qualification.practitioner': 'Игро-Практик',
  'qualification.community_ambassador': 'Амбассадор сообщества',
  'qualification.brend_ambassador': 'Амбассадор бренда',
  'qualification.company_ambassador': 'Амбассадор Компании',
  // LOGIN PAGE
  'page.login.title': 'Вход',
  'page.login.login': 'Логин',
  'page.login.phone': 'Телефон',
  'page.login.by-login': 'Войти по логину',
  'page.login.by-phone': 'Войти по телефону',
  'page.login.password': 'Пароль',
  'page.login.login-required': 'Укажите логин',
  'page.login.phone-required': 'Укажите телефон',
  'page.login.password-required': 'Укажите пароль',
  'page.login.submit-text': 'Войти',
  // 'page.login.error': 'Ошибка',
  'page.login.auth-wrong-pass-or-login-text': 'Неправильно введен логин или пароль',
  'page.login.auth-wrong-pass-or-phone-text': 'Неправильно введен телефон или пароль',
  'page.login.auth-error-text': 'Произошла ошибка при авторизации',
  // Verification
  'verification.title': 'Начало работы',
  'verification.step-0.welcome': 'Добро пожаловать в Super Ego Business',
  'verification.step-0.3-steps': 'Прежде чем мы начнем работу, Вам необходимо выполнить 3 шага',
  'verification.step-0.start': 'Начать',
  'verification.step-1.title': 'Шаг 1',
  'verification.step-1.agreement.heading': 'Соглашение',
  'verification.step-1.agreement.description': 'Все отношения между компанией Super Ego и партнёрами регулируются Соглашением. Для продолжения необходимо ознакомиться и принять условия Соглашения.',
  'verification.step-1.i-agree': 'Я принимаю условия Соглашения',
  'verification.step-1.download-pdf': 'Скачать PDF-файл',
  'verification.step-1.next': 'Далее',
  'verification.step-2.title': 'Шаг 2',
  'verification.step-2.living-city': 'Город проживания',
  'verification.step-2.city-select-text': 'Пожалуйста введите город вашего проживания в поле ниже и выберите из выпадающего списка',
  'verification.step-2.type-living-city': 'Введите город проживания',
  'verification.step-2.next': 'Далее',
  'verification.step-2.living-country': 'Страна проживания',
  'verification.step-2.your-living-country-is': 'Вы проживаете в стране:',
  'verification.step-2.citezenship-question': 'Вы являетесь гражданином этой страны, и Ваши документы выданы в указанной стране?',
  'verification.step-2.yes': 'Да',
  'verification.step-2.no': 'Нет',
  'verification.step-2.citezenship': 'Гражданство',
  'verification.step-2.citezenship-select-desc': 'Если Ваши документы выданы в другой стране, пожалуйста, укажите резедентом какой страны Вы являетесь',
  'verification.step-2.type-citezensip': 'Введите страну проживания',
  'verification.step-3.title': 'Шаг 3',
  'verification.step-3.docs-upload': 'Загрузка документов',
  'verification.step-3.docs-upload-desc': 'Для того, чтобы оформить наше партнёрство официально, необходимо загрузить следующие документы:',
  'verification.step-3.photos-note': 'Чтобы проверка прошла без проблем, убедитесь, что ваше лицо и паспортные данные хорошо видны на фотографиях.',
  'verification.step-3.docs-uploading': 'Загрузка списка необходимых документов...',
  'verification.step-3.docs-upload-server-error': 'Произошла ошибка при отправке документов на сервер',
  'verification.step-3.i-agree': 'Я даю согласие на обработку персональных данных',
  'verification.step-3.done': 'Готово',
  'verification.step-3.choose-doc': 'Выбрать фотографию',
  'verification.step-3.id-card': 'Фото паспорта',
  'verification.step-3.photo-with-id-card': 'Селфи с паспортом',
  'verification.step-4.loading': 'Загрузка',
  'verification.step-4.your-docs-on-review': 'Ваши документы проходят проверку',
  'verification.step-4.verification-duration': 'Информация обрабатывается 1–2 дня',
  'verification.step-4.description-1-line': 'Как только документы будут проверены,',
  'verification.step-4.description-2-line': 'Вам будут доступны функции Super Ego Business',
  'verification.step-4.verification-rejected': 'Верификация не пройдена',
  'verification.step-4.retry': 'Пройти проверку заново',
  'verification.step-4.congrats': 'Поздравляем!',
  'verification.step-4.second-line-desc': 'Теперь можно приступить к делу',
  'verification.step-4.time-to-set-first-target': 'Сейчас необходимо поставить Вашу первую цель в Super Ego Business',
  'verification.step-4.set-target': 'Поставить цель',
  'verification.step-4.skip-set-target': 'Пропустить',
  // CREATE GOAL
  'set-goal.title': 'Постановка цели',
  'set-goal.new-period-has-begun': 'Начинается новый отчётный период.',
  'set-goal.lets-set-goal': 'Давайте поставим цель, к которой будем двигаться.',
  'set-goal.time-to-set-new-goal': 'Пора ставить новые цели!',
  'set-goal.set-goal-by-income': 'Поставить цель на доход',
  'set-goal.you-set-goal-by-income': 'Вы ставите цель на получение дохода',
  'set-goal.dont-set': 'Не ставить цель на этот месяц',
  'set-goal.set-goal-by-qualification': 'Хочу новую квалификацию',
  'set-goal.you-set-goal-by-qualification': 'Вы выбрали цель по квалификации.',
  'set-goal.your-next-qualification': 'Ваша следующая квалификация:',
  'set-goal.requerements.required-personal-sales': '{count, plural, one {# личная продажа} many {# личных продаж} few {# личные продажи}} Master Kit',
  'set-goal.requerements.required-income': 'Доход с 2-5 уровень',
  'set-goal.requerements.title': 'Необходимые условия:',
  'set-goal.error-already-set': 'Вы уже поставили цель на текущий месяц',
  'set-goal.description': 'Делая первые шаги в бизнесе очень важно поставить конкретные, измеримые и достижимые цели. Цели в Super Ego Business ставятся каждый месяц.',
  'set-goal.income-amount-question': 'Сколько вы хотите заработать за {monthAndYear} года?',
  'set-goal.amount-placeholder': 'Сумма',
  'set-goal.by-income.prediction': 'Это приблизительно {sellsCount, plural, one {# продажа} many {# продаж} few {# продажи}} Master Kit (в зависимости от стоимости пакета)',
  'set-goal.income.you-will-get': 'С каждой продажи Master Kit вы будете получать',
  'set-goal.submit': 'Поставить цель',
  'set-goal.go-back': 'Назад к выбору цели',
  'set-goal.skip': 'Продолжить без цели',
  'set-goal.skip-confirm-question': 'Вы уверены, что хотите пропустить шаг постановки цели?',
  'set-goal.skip-confirm-description': 'Постановка цели помогает отслеживать эффективность Вашей деятельности и держать фокус',
  'set-goal.skip-finish.heading-line-1': 'Ничего страшного',
  'set-goal.skip-finish.heading-line-2': 'Вы можете поставить цель позже',
  'set-goal.skip-finish.welcome': 'Добро пожаловать в Партнёрский кабинет',
  'set-goal.skip-finish.go': 'Перейти',
  'set-goal.success.great': 'Отлично!',
  'set-goal.success.goal-set': 'Цель поставлена',
  'set-goal.success.welcome': 'Добро пожаловать в Партнёрский кабинет',
  'set-goal.success.go': 'Перейти',
  // GOAL REPORT
  'goal-report.title': 'Отчет за {monthYear}',
  'goal-report.not-found': 'Отчет не найден',
  'goal-report.period-finished': 'Отчетный период закончился. Ниже итоги по вашей цели.',
  'goal-report.your-goal': 'Ваша цель:',
  'goal-report.your-goal.get-income': 'Получить доход {amount}',
  'goal-report.your-goal.get-qualification': 'Получить квалификацию «{expQualification}»',
  'goal-report.your-goal.qualification.current-result.required-personal-sales': 'Личные продажи: {currentValue} из {required}',
  'goal-report.your-goal.qualification.current-result.required-income': 'Доход с 2-5 уровень: {currentValue} из {required}',
  'goal-report.result.created': 'Цель еще не достигнута',
  'goal-report.result.unperformed': 'К сожалению, Вы не закрыли цель',
  'goal-report.result.performed': 'Поздравляем! Вы успешно достигли цель',
  'goal-report.earnings': 'Вы заработали {amount}',
  'goal-report.show-income-details': 'Показать детализацию дохода',
  'goal-report.go-next': 'Далее',
  'goal-report.go-home-page': 'На главную',
  // FOOTER
  'footer.rightsReserved': 'Все права защищены',
  'footer.legal-information': 'Правовая информация',
  'footer.show-support-chat-button': 'Служба поддержки',
  // Refferal Links
  'page.ref-links.title': 'Мои ссылки',
  'page.ref-links.description.line-1': 'Ниже указаны ваши персональные ссылки на страницы покупки, сайты и так далее.',
  'page.ref-links.description.line-2': 'Контакты людей, посетивших эти ссылки и оставивших свои данные, попадают в журнал. Копируйте их и отправляйте людям.',
  'page.ref-links.table-title.name': 'Название',
  'page.ref-links.table-title.link': 'Ссылка',
  'page.ref-links.table-title.copying': 'Копирование',
  'page.ref-links.table-action.copy': 'Копировать',
  'page.ref-links.copy.success': 'Ссылка скопирована',
  'page.ref-links.copy.error': 'Не удалось скопировать ссылку, пожалуйста, скопируйте её вручную',
  // News
  'page.news.title': 'Новости',
  'page.news.go-to-list': 'К списку новостей',
  'page.news.published': 'Опубликовано',
  'page.news.other-news': 'Другие новости',
  'page.news.no-news-yet': 'No news yet',
  // Dashboard
  'page.dashboard.ancestors.title': 'Информация о наставнике',
  'page.dashboard.ancestors.nodata': 'Наставник отсутствует',
  'page.dashboard.ancestors.showAll': 'Показать всех',
  'page.dashboard.ancestors.all': 'Все наставники',
  'page.dashboard.ancestors.modal.table.level': 'Уровень',
  'page.dashboard.ancestors.modal.table.login': 'Логин',
  'page.dashboard.ancestors.modal.table.name': 'Имя',
  'page.dashboard.ancestors.modal.table.contacts': 'Контакты',
  'page.dashboard.goal.title': 'Ваша цель на {date}',
  'page.dashboard.goal.not-set': 'Цель на текущий месяц не установлена',
  'page.dashboard.goal.set-goal': 'Поставить цель',
  'page.dashboard.goal.income.current-result': 'Вы уже заработали',
  'page.dashboard.goal.qualification.current-result.required-personal-sales': 'Личные продажи: {currentValue} из {required}',
  'page.dashboard.goal.qualification.current-result.required-income': 'Доход с 2-5 уровень: {currentValue} из {required}',
  'page.dashboard.goal.get-qualification': 'Получить квалификацию «{expQualification}»',
  'page.dashboard.goal.business-performance': 'Бизнес-показатели',
  'page.dashboard.goal.more-details': 'Подробнее',
  'page.dashboard.finance-events.title': 'Финансовые операции',
  'page.dashboard.finance-events.show-all': 'Показать все',
  'page.dashboard.finance-events.eventByRemittance-pretext': 'партнеру',
  'page.dashboard.finance-events.eventByReceipt-pretext': 'от',
  'page.dashboard.finance-events.eventByPayment-pretext': 'за',
  'page.dashboard.sales.title': 'Продажи',
  'page.dashboard.sales.show-details': 'Показать детализацию',
  'page.dashboard.sales.from': 'от',
  'page.dashboard.sales.placeholder.no-sales': 'В вашей структуре еще не было продаж',
  'page.dashboard.sales.placeholder.explore-marketing-plan': 'Изучить маркетинг-план',
  'page.dashboard.news.title': 'Новости',
  'page.dashboard.news.empty': 'Новостей пока нет',
  'page.dashboard.news.show-all': 'Показать все',
  // Roadmap
  'roadmap.title': 'План развития',
  // FinanceEvents
  'finance-events.eventByRemittance': 'Исходящий перевод',
  'finance-events.eventByReceipt': 'Входящий перевод',
  'finance-events.eventByPayment': 'Платеж',
  'finance-events.eventByWithdrawal': 'Вывод средств',
  'finance-events.eventByPayout': 'Выплата по комиссиям',
  'finance-events.eventByGift': 'Оплата продукта партнеру',
  // FINANCE
  'page.finance.title': 'Финансы',
  'page.finance.eventByPayment-pretext': 'за',
  'page.finance.eventByRemittance-pretext': 'партнеру',
  'page.finance.eventByReceipt-pretext': 'от',
  'page.finance.filter.from': 'Время от',
  'page.finance.filter.to': 'Время до',
  'page.finance.filter.type': 'Тип операции',
  'page.finance.filter.reset': 'Сбросить фильтр',
  'page.finance.new-remittance.title': 'Перевод',
  'page.finance.new-remittance.destination-user': 'Получатель',
  'page.finance.new-remittance.type-destination-user-login': 'Введите логин получателя',
  'page.finance.new-remittance.success-message': 'Запрос на перевод денежных средств успешно отправлен',
  'page.finance.new-remittance.note': 'Примечание',
  'page.finance.new-remittance.available-amount': 'Доступно для перевода',
  'page.finance.new-remittance.submit': 'Отправить',
  'page.finance.new-remittance.confirm-text': 'Вы собираетесь выполнить перевод:',
  'page.finance.new-remittance.ok-button': 'Подтверждаю',
  'page.finance.new-remittance.cancel-button': 'Отмена',
  'page.finance.new-remittance.amount': 'Сумма',
  'page.finance.new-remittance.submit-button': 'Сделать перевод',
  'page.finance.new-remittance.alert.line-1': 'Подтверждение перевода может занимать до 24 часов.',
  'page.finance.new-remittance.alert.line-2': 'Если перевод не был подтвержден в течение этого времени, пожалуйста, обратитесь в службу поддержки.',
  'page.finance.new-remittance.alert.line-3': 'Переводы между партнёрами из РФ и зарубежных стран приостановлены.',
  'page.finance.new-withdrawal.title': 'Вывод средств',
  'page.finance.new-withdrawal.success-message': 'Запрос на вывод денежных средств успешно отправлен',
  'page.finance.new-withdrawal.withdrawal-type': 'Способ вывода средств',
  'page.finance.new-withdrawal.note.placeholder.default': 'Примечание',
  'page.finance.new-withdrawal.note.placeholder.withdrawal-type-1': 'Ваш номер телефона',
  'page.finance.new-withdrawal.note.placeholder.withdrawal-type-2': 'Полное имя и телефон',
  'page.finance.new-withdrawal.amount': 'Сумма',
  'page.finance.new-withdrawal.available-amount': 'Для вывода доступно',
  'page.finance.new-withdrawal.next': 'Далее',
  'page.finance.new-withdrawal.confirm-text': 'Вы собираетесь совершить\nвывод средств',
  'page.finance.new-withdrawal.confirm.commisiion-warning': 'С указанной суммы\nбудет удержана комиссия 4%',
  'page.finance.new-withdrawal.confirm-button': 'Подтверждаю',
  'page.finance.new-withdrawal.cancel-button': 'Отмена',
  // 'page.finance.new-withdrawal.agreement': 'ruWithdrawalAgreement', // dont translate it
  'page.finance.new-withdrawal.agreement-description': 'Перед заполнением заявки необходимо ознакомиться и принять условия  вывода средств.',
  'page.finance.new-withdrawal.exchange-rates-link-title': 'Ознакомиться с текущим курсом валют ЕЦБ',
  'page.finance.new-withdrawal.i-agree': 'Я принимаю условия вывода средств',
  'page.finance.new-withdrawal.balance-limit-error': 'Недостаточно средств для вывода',
  'page.finance.new-withdrawal.max-limit-error': 'Максимальная сумма вывода {value}',
  'page.finance.new-withdrawal.min-limit-error': 'Минимальная сумма вывода {value}',
  'page.finance.new-withdrawal.go-next': 'Далее',
  'page.finance.new-withdrawal.note': 'Дополнительная информация',
  'page.finance.new-withdrawal.note.withdrawal-type-1': 'Для вывода средств на банковскую карту необходимо предоставить её реквизиты.\nЗаполните данные и вернитесь на эту страницу.',
  'page.finance.new-withdrawal.note.withdrawal-type-1-button-caption': 'Заполнить',
  'page.finance.new-withdrawal.note.withdrawal-type-2': 'Для вывода средств юридическим лицам необходимо предоставить документы и банковские реквизиты на почту {email}',
  'page.finance.new-withdrawal.to-bank-card': 'На банковскую карту',
  'page.finance.new-withdrawal.to-checking-account': 'На расчетный счет',
  'page.finance.new-withdrawal.no-cards-placeholder': 'Вы еще не добавили ни одной карты',
  'page.finance.new-withdrawal.add-new-card': 'Добавить карту',
  'page.finance.new-withdrawal.add-new-card.prevention': 'Ввод данных вашей карты будет осуществляться в специальном&nbsp;окне платежного сервиса.<br /><br />Данные сохраняются на стороне компании <a href="https://ecommpay.com/" target="_blank">ECOMMPAY</a> и надежно хранятся согласно стандартам безопасности PCI DSS.<br /><br />Мы не будем иметь прямого доступа к реквизитам Вашей&nbsp;банковской карты.',
  'page.finance.new-withdrawal.add-new-card.input-card-data': 'Ввести данные карты',
  'page.finance.new-withdrawal.add-new-card.cancel': 'Отмена',
  'page.finance.new-withdrawal.add-new-card.success': 'Карта успешно добавлена',
  'page.finance.details.eventByRemittance-pretext': 'Партнеру ',
  'page.finance.details.EventByReceipt-pretext': 'От партнера ',
  'page.finance.details.commissions-details': 'Детализация комиссий',
  'page.finance.details.commissions-details-button-caption': 'Просмотреть',
  'page.finance.details.note': 'Комментарий',
  'page.finance.details.partner': 'Партнер',
  'page.finance.details.date': 'Дата операции',
  'page.finance.details.state': 'Текущий статус',
  'page.finance.details.id': 'ID операции',
  'page.finance.event.status.waiting': 'В ожидании',
  'page.finance.event.status.approved': 'Выполнен',
  'page.finance.event.status.rejected': 'Отклонено',
  'page.finance.event.status.canceled': 'Отменено',
  'page.finance.details.withdrawal-state-history.title': 'История изменений статуса',
  'page.finance.details.withdrawal-state-history.date': 'Дата',
  'page.finance.details.withdrawal-state-history.status': 'Статус',
  'page.finance.details.withdrawal-state-history.reason': 'Комментарий',
  'page.finance.details.withdrawal-state-history.reason-not-set': 'Не указан',
  'page.finance.details.withdrawal-state-history.empty': 'История пуста',
  // Partners
  'page.partners.table.title.level': 'Ур.',
  'page.partners.table.title.partner': 'Партнер',
  'page.partners.table.title.qualification': 'Квалификация',
  'page.partners.table.title.first-line-income': 'Доход с первой линии',
  'page.partners.table.title.total-income': 'Общий доход',
  'page.partners.table.title.goal': 'Цель',
  'page.partners.table.title.no-goal': 'Нет цели',
  'page.partners.table.title.goal.income': 'Получить доход {expAmount}',
  'page.partners.table.title.goal.qualification': 'Получить квалификацию «{expQualification}»',
  'page.partners.table.title.updated': 'Обновлен',
  'page.partners.table.title.details': 'Подробнее',
  'page.partners.table.title.show-details': 'Показать детализацию',
  'page.partners.table.title.load-more': 'Показать еще',
  'page.partners.filter.period': 'Указать период',
  'page.partners.filter.active-period': 'За активный период',
  'page.partners.filter.qualifications': 'Квалификация',
  'page.partners.filter.search': 'Поиск',
  'page.partners.filter.search-placeholder': 'Введите логин, телефон или email',
  'page.partners.filter.level': 'Уровни',
  'page.partners.filter.all-goals': 'Все цели',
  'page.partners.filter.goal-by-income': 'Цель на доход',
  'page.partners.filter.goal-by-qualification': 'Цель на квалификацию',
  'page.partners.filter.all': 'Все',
  'page.partners.filter.favorite': 'Избранные',
  'page.partners.filter.new': 'Новые',
  'page.partners.filter.hide-innactive': 'Скрыть неактивных',
  'page.partners.filter.hide-innactive-tip' :'Cкрыть партнёров, которые не поставили цель, или не получают доход в выбранный период',
  'page.partners.filter.reset': 'Сбросить фильтр',
  'page.partners.details.title': 'Бизнес показатели',
  'page.partners.details.remove-from-favorites': 'Убрать из избранных',
  'page.partners.details.add-to-favorites': 'В избранные',
  'page.partners.details.show-mentors': 'Показать наставников',
  'page.partners.details.state.unverified': 'Неверифицирован',
  'page.partners.details.state.active': 'Верифицирован',
  'page.partners.details.state.blocked': 'Неактивен',
  'page.partners.details.in-business-since': 'Master Kit куплен',
  'page.partners.details.no-goal': 'Нет цели',
  'page.partners.details.goal-income': 'Цель: доход {amount}',
  'page.partners.details.goal-qualification': 'Получить квалификацию «{expQualification}»',
  'page.partners.details.set-period': 'Указать период',
  'page.partners.details.personal-sales': 'Личные продажи',
  'page.partners.details.personal-sales-description': 'Количество продаж, совершенных по вашей реферальной ссылке в указанный период',
  'page.partners.details.personal-sales-left': 'Необходимо выполнить ещё {personalSalesLeft, plural, one {# личную продажу} many {# личных продаж} few {# личные продажи}} базового пакета',
  'page.partners.details.out-of': 'из',
  'page.partners.details.income-second-to-fifth-level': 'Доход с 2 по 5 уровень',
  'page.partners.details.income-second-to-fifth-level-description': 'Доход, полученный от продаж со второго по пятый уровень, совершенных в указанный период',
  'page.partners.details.income-second-to-fifth-level-left': 'Необходим доход {value} со 2 по 5 уровень',
  // 'page.partners.details.strong-branch-income': 'Доход с сильной ветки', // deprecated
  // 'page.partners.details.strong-branch-income-description': 'Что такое «сильная ветка?»', // deprecated
  // 'page.partners.details.strong-branch-income-hint': 'Доход должен быть менее 50% от дохода со 2-5 уровень',
  'page.partners.details.approved-qualification': 'Подтвержденная квалификация',
  'page.partners.details.approved-qualification-description': 'Подтвержденная квалификация на начало периода',
  'page.partners.details.income': 'Общий доход',
  'page.partners.details.income-description': 'Доход со всей структуры за указанный период',
  'page.partners.details.show-income-details': 'Показать детализацию',
  'page.partners.details.first-line-income': 'Доход с 1 линии',
  'page.partners.details.first-line-income-desc': 'Доход с продаж в первой линии за указанный период',
  'page.partners.details.second-to-fifth-level-income': 'Доход со 2 по 5 линии',
  'page.partners.details.second-to-fifth-level-income-desc': 'Доход, полученный от продаж со второй по пятую линии, совершенных в указанный период',
  'page.partners.details.personale-sales': 'Личные продажи',
  'page.partners.details.personale-sales-desc': 'Количество продаж базовых пакетов за указанный период',
  // 'page.partners.details.strong-branch-income-amount': 'Доход с сильной ветки',
  // 'page.partners.details.strong-branch-income-amount-desc': 'Доход, получаемый от продаж в сильной ветке за указанный период',
  'page.partners.details.personal-turnover': 'Личный объем',
  'page.partners.details.personal-turnover-desc': 'Суммарное количество баллов продаж в первой линии за указанный период',
  'page.partners.details.group-turnover': 'Групповой объем',
  'page.partners.details.group-turnover-desc': 'Суммарное количество баллов продаж во всей структуре за указанный период',
  'page.partners.details.income-from-strong-branch': 'Доход с сильной ветки',
  'page.partners.actions.leftContacts': 'Оставил контакты',
  'page.partners.actions.meeting': 'Встреча',
  'page.partners.actions.call': 'Звонок',
  'page.partners.actions.downloadedBook': 'Скачал книгу',
  'page.partners.actions.registeredOnSite': 'Регистрация на сайте',
  'page.partners.actions.boughtProduct': 'Купил продукт',
  'page.partners.actions.becamePartner': 'Стал партнером',
  'page.partners.actions.other': 'Прочее',
  // Journal
  'page.journal.tabs.contacts': 'Контакты',
  'page.journal.tabs.tasks': 'Задачи',
  'page.journal.tabs.favorites': 'Избранные',
  'page.journal.tabs.archive': 'Архив',
  'page.journal.table.lastActivity': 'Активность',
  'page.journal.table.time': 'Время',
  'page.journal.table.contact': 'Контакт',
  'page.journal.table.phone': 'Телефон',
  'page.journal.table.is-shared': 'Контакт получен от вашего партнера',
  'page.journal.add-new.add-contact': 'Добавить контакт',
  'page.journal.add-new.contact-adding': 'Добавление контакта',
  'page.journal.add-new.error': 'Произошла ошибка при добавлении контакта',
  'page.journal.add-new.required-field-message': 'Пожалуйста, заполните поле',
  'page.journal.add-new.type-name': 'Введите имя',
  'page.journal.add-new.incorrect-email-message': 'Введите корректный email',
  'page.journal.add-new.type-email': 'Введите email',
  'page.journal.add-new.type-phone': 'Введите телефон',
  'page.journal.add-new.type-note': 'Добавить примечание',
  'page.journal.group-actions.title': 'Действия с отмеченными',
  'page.journal.group-actions.archive.restore': 'Восстановить из архива',
  'page.journal.group-actions.archive.move-to-archive': 'Убрать в архив',
  'page.journal.group-actions.favorites.remove': 'Убрать из избранных',
  'page.journal.group-actions.favorites.add': 'Добавить в избранные',
  'page.journal.group-actions.change-owner.send': 'Передать партнеру',
  'page.journal.group-actions.reset-selection': 'Снять отметки',
  'page.journal.group-actions.favorites.remove.confirm': 'Вы действительно хотите убрать из избранных {count, plural, one {# контакт} many {# контактов} few {# контакта}}?',
  'page.journal.group-actions.favorites.add.confirm': 'Вы действительно хотите добавить в избранные {count, plural, one {# контакт} many {# контактов} few {# контакта}}?',
  'page.journal.group-actions.favorites.remove.success-message': '{count, plural, one {# контакт успешно убран} many {# контактов успешно убрано} few {# контакта убрано}} из избранных',
  'page.journal.group-actions.favorites.add.success-message': '{count, plural, one {# контакт успешно добавлен} many {# контактов успешно добавлено} few {# контакта успешно добавлено}} в избранные',
  'page.journal.group-actions.favorites.submit': 'Да',
  'page.journal.group-actions.favorites.cancel': 'Отмена',
  'page.journal.group-actions.archive.restored.success-message': '{count, plural, one {# контакт успешно восстановлен} many {# контактов успешно восстановлено} few {# контакта успешно восстановлено}} из архива',
  'page.journal.group-actions.archive.archived.success-message': '{count, plural, one {# контакт успешно отправлен} many {# контактов успешно отправлено} few {# контакта успешно отправлено}} в архив',
  'page.journal.group-actions.archive.restore.confirm': 'Вы действительно хотите восстановить {count, plural, one {# контакт} many {# контактов} few {# контакта}} из архива?',
  'page.journal.group-actions.archive.archive.confirm': 'Вы действительно хотите отправить {count, plural, one {# контакт} many {# контактов} few {# контакта}} в архив?',
  'page.journal.group-actions.archive.submit': 'Да',
  'page.journal.group-actions.archive.cancel': 'Отмена',
  'page.journal.group-actions.change-owner.no-forward-shared-text': 'Среди выбранных контактов есть те, которые были переданы вам от ваших партнеров. Такие контакты недоступны для дальнейшей передачи',
  'page.journal.group-actions.change-owner.description': 'Кому передать {count, plural, one {# контакт} many {# контактов} few {# контакта}}?',
  'page.journal.group-actions.change-owner.success': '{count, plural, one {# контакт успешно передан} many {# контактов успешно передано} few {# контакта успешно передано}} партнеру {name}',
  'page.journal.group-actions.change-owner.partner': 'Партнер',
  'page.journal.group-actions.change-owner.placeholder': 'Введите логин партнера',
  'page.journal.group-actions.change-owner.send-button': 'Передать',
  'page.journal.group-actions.change-owner.confirm-text': 'Вы собираетесь передать {count, plural, one {# контакт} many {# контактов} few {# контакта}}\nпартнеру {name}.\n{count, plural, one {Контакт будет удален} many {Контакты будет удалены} few {Контакты будет удалены}} из вашего журнала.\nПодтверждаете операцию?',
  'page.journal.group-actions.change-owner.cancel': 'Отмена',
  'page.journal.group-actions.change-owner.i-confirm': 'Подтверждаю',
  'page.journal.details.actions.title': 'Действия контакта',
  'page.journal.details.actions.today': 'сегодня',
  'page.journal.details.actions.yesterday': 'вчера',
  'page.journal.details.actions.created-by-you': 'Добавлено вами',
  'page.journal.details.actions.new-action.error': 'Произошла ошибка при добавлении касания',
  'page.journal.details.actions.new-action.description': 'Описание',
  'page.journal.details.actions.new-action.action-type': 'Тип касания',
  'page.journal.details.actions.new-action.save': 'Сохранить',
  'page.journal.details.actions.new-action.cancel': 'Отмена',
  'page.journal.details.actions.new-action.new-action': 'Новое касание',
  'page.journal.details.actions.new-action.add-action': 'Добавить касание',
  'page.journal.details.edit.error': 'Произошла ошибка при редактировании',
  'page.journal.details.edit.name': 'Имя',
  'page.journal.details.edit.phone': 'Телефон',
  'page.journal.details.edit.note': 'Заметка',
  'page.journal.details.edit.submit': 'Сохранить',
  'page.journal.details.edit.cancel': 'Отмена',
  'page.journal.details.edit.title': 'Редактирование',
  'page.journal.details.tags.tag-name':'Название метки',
  'page.journal.details.tags.submit': 'Добавить',
  'page.journal.details.tags.cancel': 'Отмена',
  'page.journal.details.tags.add-tag': 'Добавить метку',
  'page.journal.details.tasks.title': 'Мои задачи',
  'page.journal.details.tasks.yesterday': 'вчера',
  'page.journal.details.tasks.today': 'сегодня',
  'page.journal.details.tasks.tomorrow': 'завтра',
  'page.journal.details.new-task.error': 'Произошла ошибка при добавлении задачи',
  'page.journal.details.new-task.deadline': 'Выполнить к сроку',
  'page.journal.details.new-task.task-name': 'Задача',
  'page.journal.details.new-task.description': 'Описание',
  'page.journal.details.new-task.submit': 'Сохранить',
  'page.journal.details.new-task.cancel': 'Отмена',
  'page.journal.details.new-task.create': 'Новая задача',
  'page.journal.details.task.result': 'Каков результат?',
  'page.journal.details.task.finish': 'Завершить',
  'page.journal.details.task.cancel': 'Отмена',
  'page.journal.details.remove-from-favorites': 'Убрать из избранных',
  'page.journal.details.add-to-favorites': 'Добавить в избранные',
  'page.journal.details.remove-from-archive': 'Вернуть из архива',
  'page.journal.details.add-to-archive': 'Убрать в архив',
  'page.journal.details.contact-duplication-warning': 'Внимание, контакт находится в журнале и у других партнёров!',
  'page.journal.details.give-product.success-message': 'Заявка на активацию в обработке. Пожалуйста, подождите несколько минут.',
  'page.journal.details.give-product.error-message': 'При отправке запроса произошла ошибка. Пожалуйта, обратитесь в службу поддержки',
  'page.journal.details.give-product.gift-description': 'Вы собираетесь оплатить {productName}',
  'page.journal.details.give-product.will-debited': 'С вашего внутреннего счета будет списано',
  'page.journal.details.give-product.confirm-text': 'Подтверждаете операцию?',
  'page.journal.details.give-product.confirm.yes': 'Да',
  'page.journal.details.give-product.confirm.cancel': 'Отмена',
  'page.journal.details.give-product.title': 'Подарок партнеру',
  'page.journal.details.give-product.give-product': 'Подарить продукт',
  'page.journal.details.give-product.select-product': 'Выберите продукт',
  'page.journal.details.give-product.give': 'Подарить',
  'page.journal.details.give-product.not-enough-money': 'Недостаточно средств на вашем внутреннем счете',
  'page.journal.details.give-product.not-enough-money-amount': 'Недостающая сумма:',
  'page.journal.details.give-product.select-product.empty': 'Список продуктов пуст',
  'page.journal.details.is-shared': 'Контакт получен от партнера {name}',
  'page.journal.filter.search-placeholder': 'Имя, телефон, email, теги...',
  'page.journal.filter.period-placeholder': 'Указать период',
  'page.journal.filter.reset': 'Сбросить фильтр',
  'page.journal.filter.period.primary': 'Основные',
  'page.journal.filter.period.favorites': 'Избранные',
  'page.journal.filter.period.archive': 'Архив',
  'page.journal.filter.isBoughtBaseProduct': 'MK куплен',
  'page.journal.filter.isNotBoughtBaseProduct': 'МК не куплен',
  'page.journal.filter.isNotBoughtBaseProduct.tooltip': "Показывать только тех, кто не купил Master Kit",
  // 'page.journal.tasks-list.overdue-tasks': 'Просроченные',
  // 'page.journal.tasks-list.today-tasks': 'На сегодня',
  // 'page.journal.tasks-list.tomorrow-tasks': 'На завтра',
  'page.journal.tasks-list.filter.state.finished': 'Завершенные',
  'page.journal.tasks-list.filter.state.unfinished': 'Запланированнные',
  'page.journal.tasks-list.table.deadline': 'Выполнить к сроку',
  'page.journal.tasks-list.table.date-time': 'Дата и время',
  'page.journal.tasks-list.table.task-title': 'Задача',
  'page.journal.tasks-list.table.task-result': 'Результат',
  'page.journal.tasks-list.table.contact': 'Контакт',
  'page.journal.utils.today': 'сегодня',
  'page.journal.utils.yesterday': 'вчера',
  'page.journal.at': 'в',
  'page.journal.utils.all-periods': 'За все время',
  'page.journal.utils.added-today': 'За сегодня',
  'page.journal.utils.added-last-week': 'За неделю',
  'page.journal.utils.added-last-month': 'За месяц',
  'page.journal.utils.added-last-year': 'За год',
  'page.journal.contact.new': 'Новый',
  'page.journal.add-new.error.already-exists': 'Контакт с таким email или телефоном уже есть в системе',
  'page.journal.details.change-owner.title': 'Передача контакта партнеру',
  'page.journal.details.change-owner.tooltip-title': 'Передать контакт партнеру',
  'page.journal.details.change-owner.partner.placeholder': 'Партнер',
  'page.journal.details.change-owner.partner.tip': 'Введите логин партнера',
  'page.journal.details.change-owner.send': 'Передать',
  'page.journal.details.change-owner.i-confirm': 'Подтверждаю',
  'page.journal.details.change-owner.cancel': 'Отмена',
  'page.journal.details.change-owner.confirmation-text': 'Вы собираетесь передать контакт партнеру {firstname} {lastname}\nКонтакт будет удален из вашего журнала\nПодтверждаете операцию?',
  'page.journal.details.change-owner.success-message': 'Контакт {contactName} успешно передан партнеру {firstname} {lastname}',
  // photobank
  'page.photobank.description': 'Здесь вы можете скачать профессиональные фотографии с Master Kit. Смело используйте их для своих постов в соц.сетях!',
  'page.photobank.download': 'Скачать',
  // presentations
  'page.files.download': 'Скачать',
  // videobank
  'page.videobank.description': 'Здесь собраны все видеоматериалы Super Ego, от видео про Master Kit до ярких воспоминаний с промо. Делитесь этими видео со своими друзьями, клиентами и партнерами! Обратите внимание, что ссылки не реферальные',
  'page.videobank.action.open': 'Открыть',
  'page.videobank.action.copy-link': 'Скопировать ссылку',
  'page.videobank.action.copy-link.success': 'Ссылка успешно скопирована',
  'page.videobank.action.copy-link.error': 'Не удалось скопировать ссылку',
  // sales report
  'page.sales-report.table.title': 'Продукт',
  'page.sales-report.table.price': 'Цена',
  'page.sales-report.table.count': 'Кол-во',
  'page.sales-report.table.comission': 'Баллы',
  'page.sales-report.table.totalAmount': 'Сумма',
  'page.sales-report.table.total': 'Итого',
  'page.sales-report.table.showDetails': 'Подробнее',
  // 'page.sales-report.filter.product': 'Продукт',
  'page.sales-report.filter.category': 'Категория',
  'page.sales-report.filter.partner': 'Партнёр',
  'page.sales-report.filter.partner-placeholder': 'Введите логин, телефон или email',
  'page.sales-report.filter.from': 'Дата от',
  'page.sales-report.filter.to': 'Дата до',
  'page.sales-report.filter.reset': 'Сбросить',
  'page.sales-report.details.table.id': 'ID',
  'page.sales-report.details.table.buyer': 'Покупатель',
  'page.sales-report.details.table.time': 'Дата оплаты',
  'page.sales-report.details.table.price': 'Цена',
  'page.sales-report.details.table.commission': 'Баллы',
  // business reputation intro
  'page.business-reputation-intro.title': 'Business Reputation',
  'page.business-reputation-intro.step-1.title-1': 'Встречайте',
  'page.business-reputation-intro.step-1.title-2': 'Business Reputation!',
  /* обновлено 25.05.20 */'page.business-reputation-intro.step-1.text': 'Мы адаптировали Performance Review — систему,\nиспользуемую ведущими IT-компаниями мира\nдля оценки мотивации и вовлеченности сотрудников.\n\nИ теперь мы внедряем эту систему в нашу партнерскую сеть!',
  'page.business-reputation-intro.step-1.go-next-button': 'Как это работает?',
  'page.business-reputation-intro.step-2.title': 'Как это работает?',
  /* обновлено 25.05.20 */'page.business-reputation-intro.step-2.text': 'Мы собираем обратную связь с помощью анонимных опросов\nо взаимодействии с Вами от клиентов, наставников и Вашей команды.\n\nВам в свою очередь также предстоит оценить\nВашего наставника и участников собственной команды.\n\nПолученную обратную связь с помощью специальной формулы\nмы преобразуем в оценку (или рейтинг) — Business Reputation (BR).\n\nЭта оценка будет отображатся в партнерском кабинете\nв верхнем левом углу, рядом с доступными средствами. ',
  'page.business-reputation-intro.step-2.go-next-button': 'Что мне это дает?',
  'page.business-reputation-intro.step-3.title': 'Что мне это дает?',
  /* обновлено 25.05.20 */'page.business-reputation-intro.step-3.text': 'Оценка Business Reputation (BR) позволяет понять, какие из партнеров\nболее лояльны к бизнесу и максимально вовлечены.\n\nТакже Вы получите обратную связь о Ваших «узких» местах\nи поймете, над чем Вам стоит поработать.\n\nВ дальнейшем партнерам с более высокой оценкой BR\nбудут открываться новые эксклюзивные возможности.\n\nИ наоборот, по отношению к партнерам с низкой\nили отрицательной оценкой будут введены ограничения.',
  'page.business-reputation-intro.step-3.go-next-button': 'Понятно',
  'page.business-reputation-intro.step-3.show-more-button': 'Подробнее про Business Reputation',
  'page.business-reputation-intro.step-3.long-text': 'businessReputationDocRu',
  // 404
  'page.404.title': 'Страница не найдена',
  'page.404.go-home': 'На главную',
  // 403
  'page.403.title': 'Доступ запрещен – недостаточно прав',
  'page.403.title-short': 'Доступ запрещен',
  'page.403.description': 'Недостаточно прав для просмотра данного ресурса',
  'page.403.go-home': 'На главную',
  // ERRORS
  'error.no-access-short': 'Ошибка доступа',
  'error.request-error': 'Ошибка выполнения запроса',
  'error.no-access': 'Ошибка доступа. Недостаточно прав для выполнения операции',
  'error.internal-server-error': 'При выполнении запроса произошла внутренняя ошибка сервера',
  'error.no-connection': 'Ошибка соединения. Проверьте подключение к интернету.',
}

const cache = createIntlCache()

const intl = createIntl({
  locale: 'ru',
  messages,
  antdData
}, cache)

export default intl;
